<script>
  export default {
    name: 'Home',
  }
</script>

<template>
  <!--START HOME-->
  <section
    class="section bg-home home-half"
    id="home"
    style="background-size: cover; background-position: center"
    :style="{ background: 'url(' + require('@/assets/images/banner.1.png') + ')' }"
  >
    <div class="bg-overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 offset-lg-3 text-white text-center">
          <h4 class="home-small-title"
            >¿Quieres invertir tu dinero <br>en un negocio exitoso?</h4
          >
          <h1 class="home-title">¡Invierte en una Franquicia DIU!</h1>
          <h2 class="home-small-title">Droguería Industrial Uruguaya</h2>
          <h4 class="padding-t-10 home-desc mx-auto">
            Con más de 85 años de trayectoria en el mercado
          </h4>
          <p class="play-shadow margin-l-r-auto">
            <a v-b-modal.modal class="play-btn video-play-icon text-white">
              <i class="mdi mdi-play text-center"></i>
            </a>
            <b-modal
              id="modal"
              hide-footer
              size="lg"
              centered
              header-close-variant="white"
            >
              <!-- <youtube
                video-id="lG0Ys-2d4MA"
                ref="youtube"
                width="900"
                height="500"
              ></youtube> -->

              <iframe
                src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FDrogIndUruguaya%2Fvideos%2F432276438548748%2F&show_text=false&width=560&t=0"
                width="900"
                height="500"
                style="border: none; overflow: hidden"
                scrolling="no"
                frameborder="0"
                allowfullscreen="true"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            </b-modal>
          </p>
          <img src="@/assets/images/diu.1.png" style="max-width: 250px" />
        </div>
      </div>
    </div>
  </section>
  <!--END HOME-->
</template>
